import z from 'zod';

//shipping-navigation
export type ShippingNavigation = z.output<typeof ShippingNavigationSchema>;
export const ShippingNavigationSchema = z.object({
  label: z.string(),
  mainLink: z.string(),
  link1: z.string(),
  link2: z.string(),
  link3: z.string(),
  link4: z.string()
});

//contact-us
export type ContactUs = z.output<typeof ContactUsSchema>;
export const ContactUsSchema = z.object({
  label: z.string(),
  email: z.string(),
  liveChat: z.string(),
  weChat: z.string(),
  phone: z.string(),
  phoneFR: z.string(),
  phoneUK: z.string(),
  phoneBE: z.string(),
  phoneES: z.string(),
  phoneFRLabel: z.string(),
  phoneESLabel: z.string(),
  phoneUKLabel: z.string(),
  phoneBELabel: z.string(),
});

//customs
export type Customs = z.output<typeof CustomsSchema>;
export const CustomsSchema = z.object({
  label: z.string(),
  info: z.string(),
  address: z.string()
});

//customs
export type NewsletterSmall = z.output<typeof NewsletterSmallSchema>;
export const NewsletterSmallSchema = z.object({
  label: z.string(),
  placeholder: z.string(),
  cta: z.string(),
  info: z.string(),
  successConfirmationMessage: z.string(),
  success: z.string(),
  thanks: z.string()
});

//become-partner
export type BecomePartner = z.output<typeof BecomePartnerSchema>;
export const BecomePartnerSchema = z.object({
  label: z.string(),
  cta: z.string(),
});

// travelers-navigation
export type FooterTravelersNavigation = z.output<typeof FooterTravelersNavigationSchema>;
export const FooterTravelersNavigationSchema = z.object({
  label: z.string(),
  mainLink: z.string(),
  link1: z.string(),
  link2: z.string(),
  link3: z.string(),
  link4: z.string(),
  link5: z.string(),
});

// shops-navigation
export type FooterShopsNavigation = z.output<typeof FooterShopsNavigationSchema>;
export const FooterShopsNavigationSchema = z.object({
  label: z.string(),
  mainLink: z.string(),
  link1: z.string(),
  link2: z.string(),
  link3: z.string(),
  link4: z.string(),
  link5: z.string(),


});

// about-us-navigation
export type FooterAboutUsNavigation = z.output<typeof FooterAboutUsNavigationSchema>;
export const FooterAboutUsNavigationSchema = z.object({
  label: z.string(),
  link1: z.string(),
  link2: z.string(),
  link3: z.string(),
  link4: z.string(),
  link5: z.string(),
});


export type FooterComponent = BecomePartner | ContactUs | NewsletterSmall | Customs | FooterTravelersNavigation | FooterShopsNavigation | FooterAboutUsNavigation;
